import { render, staticRenderFns } from "./EditSubscriber.vue?vue&type=template&id=f5909bc2&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"
import style0 from "./EditSubscriber.vue?vue&type=style&index=0&id=f5909bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5909bc2",
  null
  
)

export default component.exports